import { buildProductImageURL } from "~/plugins/dimg"

export default function useProductImageURL (params: object): string {
  return buildProductImageURL(params)
}